export function getRootElement() {
  const rootElement = document.querySelector(
    `[data-tool='solvari-contact-form']`,
  );

  if (!rootElement) {
    throw new Error("No root element found");
  }

  return rootElement;
}
